import { FunctionComponent, HTMLAttributes } from 'react';

const IconGallery: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => (
  <svg
    {...props}
    viewBox="0 0 18 16"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
  >
    <path
      d="M15.0877 3.38333V2.85C15.0865 2.42603 14.9176 2.01978 14.6178 1.71999C14.318 1.4202 13.9117 1.25123 13.4877 1.25H2.82108C2.39711 1.25123 1.99086 1.4202 1.69107 1.71999C1.39128 2.01978 1.22231 2.42603 1.22108 2.85V11.3833C1.22231 11.8073 1.39128 12.2136 1.69107 12.5133C1.99086 12.8131 2.39711 12.9821 2.82108 12.9833H3.35441"
      stroke="currentcolor"
      strokeLinejoin="round"
    />
    <path
      d="M15.6881 3.91663H5.42075C4.57409 3.91663 3.88774 4.60297 3.88774 5.44963V13.5836C3.88774 14.4303 4.57409 15.1166 5.42075 15.1166H15.6881C16.5347 15.1166 17.2211 14.4303 17.2211 13.5836V5.44963C17.2211 4.60297 16.5347 3.91663 15.6881 3.91663Z"
      stroke="currentcolor"
      strokeLinejoin="round"
    />
    <path
      d="M13.1184 7.98967C13.6849 7.98967 14.1441 7.53375 14.1441 6.97134C14.1441 6.40893 13.6849 5.953 13.1184 5.953C12.552 5.953 12.0927 6.40893 12.0927 6.97134C12.0927 7.53375 12.552 7.98967 13.1184 7.98967Z"
      stroke="currentcolor"
      strokeMiterlimit="10"
    />
    <path
      d="M9.52874 15.1167L13.4817 11.1923C13.6636 11.0129 13.9056 10.9073 14.1608 10.8958C14.416 10.8843 14.6664 10.9677 14.8637 11.13L17.2211 13.0803M12.0927 12.0557L9.18774 9.17601C9.00204 8.99253 8.75364 8.88633 8.49269 8.87884C8.23174 8.87136 7.97766 8.96314 7.78174 9.13568L3.88774 12.5713L12.0927 12.0557Z"
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconGallery;
